import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/shadcn/select';
import { cn } from '@/lib/utils';

export interface SimpleSelectOption {
  value: string;
  label: React.ReactNode;
  disabled?: boolean;
}

interface SimpleSelectProps {
  value: string;
  onValueChange: (value: string) => void;
  options: SimpleSelectOption[];
  placeholder?: string;
  disabled?: boolean;
  className?: string;
  triggerClassName?: string;
  contentClassName?: string;
  id?: string;
  'aria-label'?: string;
}

const SimpleSelect = ({
  value,
  onValueChange,
  options,
  placeholder,
  disabled,
  className,
  triggerClassName,
  contentClassName,
  id,
  'aria-label': ariaLabel,
}: SimpleSelectProps) => {
  const selectableOptions = options.filter((option) => option.value !== '');
  const hasEmptyOption = options.some((option) => option.value === '');
  const selectValue = value === '' ? undefined : value;

  return (
    <div className={cn('w-full', className)}>
      <Select value={selectValue} onValueChange={onValueChange} disabled={disabled}>
        <SelectTrigger id={id} className={triggerClassName} aria-label={ariaLabel}>
          <SelectValue
            placeholder={
              placeholder ??
              (hasEmptyOption ? options.find((o) => o.value === '')?.label : undefined)
            }
          />
        </SelectTrigger>
        <SelectContent className={contentClassName}>
          {selectableOptions.map((option) => (
            <SelectItem key={option.value} value={option.value} disabled={option.disabled}>
              {option.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};

export default SimpleSelect;
